import { Component, OnInit, Input, ElementRef, ViewChild } from '@angular/core'
import { EnrollmentDetail } from '../../models/en-details'
import { EnrollmentGateway } from '../../gateways/enrollment-gateway'
import { EnrollmentViewModel } from '../../models/enrollment-view-model'
import { FormValidationService } from '../../../validations/form-validation-service'
import { UserAccessGateway } from '../../../common/gateways/user-access-gateway'
import { SubmitEnrollmentDataResponse } from '../../models/submit-enrollment-data-response'
import { ActivatedRoute, Params } from '@angular/router'
import { Router } from '@angular/router'
import { PortalGlobals } from '../../../portalglobals'
import { UtilsService } from '../common/utils-service'
import { IndvRepComponent } from '../common/indvrep.component'

@Component({
    selector: 'EAppStage2Enrollment',
    templateUrl: 'e-app-stage2-enrollment.component.html'
})
export class EAppStage2EnrollmentComponent implements OnInit {
    get address(): EnrollmentDetail {
        return this.enrollmentDetail
    }
    enrollmentDetail: EnrollmentDetail = {} as EnrollmentDetail
    enrollmentViewModel: EnrollmentViewModel = {} as EnrollmentViewModel
    isValidAgent: boolean
    showUpdatesSettingsMessage = 'Success'
    hasError: boolean
    ErrorMessages: any[] = []
    id: string
    isAuthRep: boolean
    finalsubmit: boolean = false
    private uniqueLink: string
    @ViewChild('focusableEleTop', { static: true }) focusableEleTop: ElementRef
    public loading: boolean = false
    constructor(
        private _enrollementGateway: EnrollmentGateway,
        private _indvRepComponent: IndvRepComponent,
        private route: ActivatedRoute,
        private router: Router,
        private utils: UtilsService,
        protected formValidationService: FormValidationService,
        private _userAccessGateway: UserAccessGateway,
        public _global: PortalGlobals
    ) {}

    ngOnInit() {
        this.hasError = false
        this.isAuthRep = false
        this.getParams()
        if (this.id === '3') {
            this.finalsubmit = true
        }

        var User = localStorage.getItem('UserSessionContext')
        this._global.currentUser = JSON.parse(User!)
        const insCo = this._global.currentUser.insuranceCompanyShortName.toLowerCase()

        this.enrollmentViewModel = this._enrollementGateway.getEnrollmentViewModel()
        this.getbackData()
        this.clearebackData()
        this.enrollmentViewModel.BENEFICIARYSIGN = ''
        if (
            this.enrollmentViewModel === undefined ||
            this.enrollmentViewModel === null ||
            this.enrollmentViewModel.HICN === undefined ||
            this.enrollmentViewModel.HICN === ''
        ) {
        }
        //this.enrollmentDetail.Email = this.enrollmentViewModel.APPEMAIL
        //this.enrollmentDetail.AgentName = this.enrollmentViewModel.AGENTNAME
        //this.enrollmentDetail.BeneficiarySign = this.enrollmentViewModel.beneficiaryInfo.firstName
    }

    rblAuthorizedRepClick(event: any): void {
        if (event === 'Yes') {
            this.isAuthRep = true
        } else {
            this.isAuthRep = false
        }
        this.enrollmentViewModel.AUTHREPIND = event
    }

    onSubmit(): void {
        //this.enrollmentViewModel.AGENTFN = this.enrollmentDetail.AgentName
        //this.enrollmentViewModel.AgentSignature = this.enrollmentDetail.AgentSignature
        //this.enrollmentViewModel.APPEMAIL = this.enrollmentDetail.Email
        this.loading = true
        this.hasError = false
        this.ErrorMessages = []
        if (this.isInitialFormSubmit()) {
            this.hasError = true
            this.loading = false
            this.focusableEleTop.nativeElement.focus()
        }
        const insCo = this._global.currentUser.insuranceCompanyShortName.toLowerCase()

        if (!this.hasError) {
            let selReasonCD = this.enrollmentViewModel.SEPREASONCD
            this.enrollmentViewModel.SEPREASONCD = Number(this.enrollmentViewModel.ELECTIONTYPEID)

            //Remove Data fro the Individual
            if (!(this.enrollmentViewModel.INDREPIND === 'Yes')) {
                this._indvRepComponent.selectedNo(this.enrollmentViewModel)
            }

            this._enrollementGateway.UpdateElectronicEnrollmentData(this.enrollmentViewModel).subscribe(
                (model: SubmitEnrollmentDataResponse) => {
                    let response = model
                    if (response !== undefined) {
                        if (response.Errors !== undefined && response.Errors.length > 0) {
                            this.hasError = false

                            for (let i = 0; i < response.Errors.length; i++) {
                                this.ErrorMessages.push(response.Errors[i].ErrorMessage)
                            }
                            this.enrollmentViewModel.SEPREASONCD = selReasonCD
                            this.hasError = true
                            this.loading = false
                            this.focusableEleTop.nativeElement.focus()
                        } else {
                            this.enrollmentViewModel.SEPREASONCD = selReasonCD
                            this._enrollementGateway.setEnrollmentViewModel(this.enrollmentViewModel)
                            this._enrollementGateway.SendEmailUser().subscribe(
                                () => (this.showUpdatesSettingsMessage = 'Success'),
                                (error) => {
                                    this.loading = false
                                }
                            )
                            this.enrollmentViewModel = {} as EnrollmentViewModel
                            this.enrollmentViewModel = this._enrollementGateway.getEnrollmentViewModel()
                            this._enrollementGateway.setEnrollmentViewModel(this.enrollmentViewModel)
                            this.loading = false
                            this.router.navigate(['/' + insCo + '/enrollment/e-application/messages/' + '1'])
                        }
                    } else {
                        this.enrollmentViewModel.SEPREASONCD = selReasonCD
                        this.ErrorMessages.push('Error while submitting data, please try again.')
                        this.hasError = true
                        this.loading = false
                        this.focusableEleTop.nativeElement.focus()
                    }
                },
                (err) => {
                    this.ErrorMessages.push('Error while submitting data, please try again.')
                    this.hasError = true
                    this.loading = false
                    this.focusableEleTop.nativeElement.focus()
                    this.loading = false
                }
            )
        }
    }

    isInitialFormSubmit(): boolean {
        if (this.enrollmentViewModel.AGENTNAME === undefined || this.enrollmentViewModel.AGENTNAME === '') {
            this.ErrorMessages.push('Agent Name is required')
            this.hasError = true
        }
        if (
            this.enrollmentViewModel.AgentSignature === undefined ||
            this.enrollmentViewModel.AgentSignature == null ||
            this.enrollmentViewModel.AgentSignature === ''
        ) {
            this.ErrorMessages.push('Agent Signature is required')
            this.hasError = true
        }
        if (this.enrollmentViewModel.APPEMAIL === undefined || this.enrollmentViewModel.APPEMAIL === '') {
            this.ErrorMessages.push('Email is required')
            this.hasError = true
        } else {
            if (
                this.enrollmentViewModel.APPEMAIL !== undefined &&
                this.enrollmentViewModel.APPEMAIL !== '' &&
                this.enrollmentViewModel.APPEMAIL !== null
            ) {
                let checkOrgEmail = this.enrollmentViewModel.APPEMAIL.toLowerCase()
                let isOrgEmailValid = this.isValidEmail(checkOrgEmail)
                if (!isOrgEmailValid) {
                    this.hasError = true
                    this.ErrorMessages.push('Invalid Email address for Electronic Application')
                }
            }
        }
        if (this.enrollmentViewModel.SOA === undefined || this.enrollmentViewModel.SOA === '') {
            this.ErrorMessages.push('Select Scope of Appointment')
            this.hasError = true
        }
        if (
            this.enrollmentViewModel.APPEMAIL !== undefined &&
            this.enrollmentViewModel.APPEMAIL !== '' &&
            this.enrollmentViewModel.AGENTDETAILS.email !== undefined &&
            this.enrollmentViewModel.AGENTDETAILS.email !== ''
        )
            if (this.enrollmentViewModel.APPEMAIL.toUpperCase() === this.enrollmentViewModel.AGENTDETAILS.email.toUpperCase()) {
                this.ErrorMessages.push('The beneficiary’s e-mail address must not match the Agent’s e-mail address.')
                this.hasError = true
            }
        if (this.enrollmentViewModel.INDREPIND === 'Yes') {
            if (
                this.enrollmentViewModel.INDREPNAME === undefined ||
                this.enrollmentViewModel.INDREPNAME === null ||
                this.enrollmentViewModel.INDREPNAME == ''
            ) {
                this.ErrorMessages.push('Individual Rep Name is required')
                this.hasError = true
            }
            if (
                this.enrollmentViewModel.RELTOENROLL === undefined ||
                this.enrollmentViewModel.RELTOENROLL === null ||
                this.enrollmentViewModel.RELTOENROLL == ''
            ) {
                this.ErrorMessages.push('Relationship to enrollee is required')
                this.hasError = true
            }
            if (
                (this.enrollmentViewModel.displayRELTOENROLL == 'Agent' || this.enrollmentViewModel.displayRELTOENROLL == 'Broker') &&
                (this.enrollmentViewModel.NPN === undefined || this.enrollmentViewModel.NPN === null || this.enrollmentViewModel.NPN == '')
            ) {
                this.ErrorMessages.push('National Producer Number is required')
                this.hasError = true
            }

            if (this.enrollmentViewModel.NPN != undefined && this.enrollmentViewModel.NPN != null && this.enrollmentViewModel.NPN != '') {
                if (!this.utils.isValidNPN(this.enrollmentViewModel.NPN)) {
                    this.hasError = true
                    this.ErrorMessages.push('Invalid NPN')
                }
            }
        }
        return this.hasError
    }

    private isValidEmail(text: string): boolean {
        return /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,}|[0-9]{1,3})(\]?)$/.test(text)
    }

    isFormInvalid(): boolean {
        this.hasError = false

        //if (this.enrollmentViewModel.APPSIGNEDIND === undefined || this.enrollmentViewModel.APPSIGNEDIND === null) {
        //    this.ErrorMessages.push('Please check Beneficiary has signed application')
        //    this.hasError = true

        //}
        if (this.enrollmentViewModel.AUTHREPIND === undefined || this.enrollmentViewModel.AUTHREPIND === null) {
            this.ErrorMessages.push('Authorized Representative is required')
            this.hasError = true
        }

        if (this.enrollmentViewModel.AUTHREPIND) {
            if (this.enrollmentViewModel.AUTHREPNAME === undefined || this.enrollmentViewModel.AUTHREPNAME === '') {
                this.ErrorMessages.push('Authorize Representative Name is required')
                this.hasError = true
            }
            if (this.enrollmentViewModel.AUTHREPREL === undefined || this.enrollmentViewModel.AUTHREPREL === '') {
                this.ErrorMessages.push('Authorize Representative Relationship is required')
                this.hasError = true
            }
            if (this.enrollmentViewModel.AUTHREPST === undefined || this.enrollmentViewModel.AUTHREPST === '') {
                this.ErrorMessages.push('Authorize Representative State is required')
                this.hasError = true
            }
            if (this.enrollmentViewModel.AUTHREPADD1 === undefined || this.enrollmentViewModel.AUTHREPADD1 === '') {
                this.ErrorMessages.push('Authorize Representative Address is required')
                this.hasError = true
            }
            if (this.enrollmentViewModel.AUTHREPCITY === undefined || this.enrollmentViewModel.AUTHREPCITY === '') {
                this.ErrorMessages.push('Authorize Representative City is required')
                this.hasError = true
            }
            if (this.enrollmentViewModel.AUTHREPZIP === undefined || this.enrollmentViewModel.AUTHREPZIP === '') {
                this.ErrorMessages.push('Authorize Representative Zip is required')
                this.hasError = true
            }
        }

        if (this.enrollmentViewModel.INDREPIND === 'Yes') {
            if (
                this.enrollmentViewModel.INDREPNAME === undefined ||
                this.enrollmentViewModel.INDREPNAME === null ||
                this.enrollmentViewModel.INDREPNAME == ''
            ) {
                this.ErrorMessages.push('Individual Rep Name is required')
                this.hasError = true
            }
            if (
                this.enrollmentViewModel.RELTOENROLL === undefined ||
                this.enrollmentViewModel.RELTOENROLL === null ||
                this.enrollmentViewModel.RELTOENROLL == ''
            ) {
                this.ErrorMessages.push('Relationship to enrollee is required')
                this.hasError = true
            }
            if (
                (this.enrollmentViewModel.displayRELTOENROLL == 'Agent' || this.enrollmentViewModel.displayRELTOENROLL == 'Broker') &&
                (this.enrollmentViewModel.NPN === undefined || this.enrollmentViewModel.NPN === null || this.enrollmentViewModel.NPN == '')
            ) {
                this.ErrorMessages.push('National Producer Number is required')
                this.hasError = true
            }

            if (this.enrollmentViewModel.NPN != undefined && this.enrollmentViewModel.NPN != null && this.enrollmentViewModel.NPN != '') {
                if (!this.utils.isValidNPN(this.enrollmentViewModel.NPN)) {
                    this.hasError = true
                    this.ErrorMessages.push('Invalid NPN')
                }
            }
        }

        return this.hasError
    }

    onAgreeChange(enrollmentDetail): void {
        this.enrollmentDetail = enrollmentDetail
        this.isValidAgent = this.enrollmentViewModel.BGCHECK
        console.log(this.enrollmentDetail.Email)
    }

    getParams() {
        this.route.params.forEach((params: Params) => {
            this.uniqueLink = this.route.snapshot.params['guid']
            this.id = this.route.snapshot.params['id']
        })
    }
    btnBack() {
        this._enrollementGateway.setEnrollmentViewModel(this.enrollmentViewModel)
        const insCo = this._global.currentUser.insuranceCompanyShortName.toLowerCase()
        this.router.navigate(['/' + insCo + '/enrollment/e-app/' + this.enrollmentViewModel.UNIQUELINK + '/' + 'verify'])
    }

    setbackData() {
        localStorage.setItem('eappstage2INDREPIND', this.enrollmentViewModel.INDREPIND)

        if (this.enrollmentViewModel.INDREPIND === 'Yes') {
            localStorage.setItem('eappstage2INDREPNAME', this.enrollmentViewModel.INDREPNAME)
            localStorage.setItem('eappstage2NPN', this.enrollmentViewModel.NPN)
            localStorage.setItem('eappstage2RELTOENROLL', this.enrollmentViewModel.RELTOENROLL)
            localStorage.setItem('eappstage2displayRELTOENROLL', this.enrollmentViewModel.displayRELTOENROLL)
        } else {
            this.enrollmentViewModel.INDREPNAME = ''
            this.enrollmentViewModel.NPN = ''
            this.enrollmentViewModel.RELTOENROLL = ''
            this.enrollmentViewModel.displayRELTOENROLL = ''
        }
    }
    getbackData() {
        if (localStorage.getItem('eappstage2INDREPNAME') != null) {
            this.enrollmentViewModel.INDREPNAME = localStorage.getItem('eappstage2INDREPNAME') || ''
        }
        if (localStorage.getItem('eappstage2NPN') != null) {
            this.enrollmentViewModel.NPN = localStorage.getItem('eappstage2NPN') || ''
        }
        if (localStorage.getItem('eappstage2RELTOENROLL') != null) {
            this.enrollmentViewModel.RELTOENROLL = localStorage.getItem('eappstage2RELTOENROLL') || ''
        }
        if (localStorage.getItem('eappstage2INDREPIND') != null) {
            this.enrollmentViewModel.INDREPIND = localStorage.getItem('eappstage2INDREPIND') || ''
        }
        if (localStorage.getItem('eappstage2displayRELTOENROLL') != null) {
            this.enrollmentViewModel.displayRELTOENROLL = localStorage.getItem('eappstage2displayRELTOENROLL') || ''
        }
    }
    clearebackData() {
        localStorage.removeItem('eappstage2INDREPNAME')
        localStorage.removeItem('eappstage2NPN')
        localStorage.removeItem('eappstage2RELTOENROLL')
        localStorage.removeItem('eappstage2INDREPIND')
        localStorage.removeItem('eappstage2displayRELTOENROLL')
    }
    btnPrevious() {
        this._enrollementGateway._backClicked = false
        this.enrollmentViewModel.ISBACK = true
        this.setbackData()
        this._enrollementGateway.setEnrollmentViewModel(this.enrollmentViewModel)
        const insCo = this._global.currentUser.insuranceCompanyShortName.toLowerCase()
        this.router.navigate(['/' + insCo + '/enrollment/e-app/' + this.enrollmentViewModel.UNIQUELINK])
    }
    onSubmitmyApp() {
        this.hasError = false

        const insCo = this._global.currentUser.insuranceCompanyShortName.toLowerCase()

        if (!this.isFormInvalid) {
            this.hasError = true
            this.focusableEleTop.nativeElement.focus()
        } else {
            this.enrollmentViewModel.SUBMISSIONTYPECODE = 'COMPLETE'
            // this.router.navigate(['enrollment/e-application/messages/' + "5"])
            //this.router.navigate(['enrollment/e-application/messages/5'])
            this.enrollmentViewModel.DEX = 'AGNTP'
            this.enrollmentViewModel.AGENTDEX = 'EENRL'

            //Remove Data fro the Individual
            if (!(this.enrollmentViewModel.INDREPIND === 'Yes')) {
                this._indvRepComponent.selectedNo(this.enrollmentViewModel)
            }

            this._enrollementGateway.SubmitEnrollmentData(this.enrollmentViewModel).subscribe((model: SubmitEnrollmentDataResponse) => {
                let response = model
                if (response !== undefined) {
                    if (response.Errors !== undefined && response.Errors.length > 0) {
                        this.hasError = false

                        for (let i = 0; i < response.Errors.length; i++) {
                            this.ErrorMessages.push(response.Errors[i].ErrorMessage)
                        }
                        this.hasError = true
                        this.focusableEleTop.nativeElement.focus()
                    } else {
                        if (response.confirmationNumber !== undefined && response.confirmationNumber !== null && response.confirmationNumber !== '') {
                            this.enrollmentViewModel.CONF = response.confirmationNumber
                            this._enrollementGateway.setEnrollmentViewModel(this.enrollmentViewModel)
                        }
                        this.enrollmentViewModel.AppStatus = 'Signed'
                        let selReasonCD = this.enrollmentViewModel.SEPREASONCD
                        this.enrollmentViewModel.SEPREASONCD = Number(this.enrollmentViewModel.ELECTIONTYPEID)
                        this._enrollementGateway
                            .UpdateElectronicEnrollmentData(this.enrollmentViewModel)
                            .subscribe((model: SubmitEnrollmentDataResponse) => {
                                this.enrollmentViewModel.SEPREASONCD = selReasonCD
                                let response = model
                                if (response !== undefined) {
                                    if (response.Errors !== undefined && response.Errors.length > 0) {
                                        this.hasError = false

                                        for (let i = 0; i < response.Errors.length; i++) {
                                            this.ErrorMessages.push(response.Errors[i].ErrorMessage)
                                        }
                                        this.hasError = true
                                        this.focusableEleTop.nativeElement.focus()
                                    } else {
                                        this.router.navigate(['/' + insCo + '/enrollment/e-application/messages/5'])

                                        // this.router.navigate(['enrollment/e-application/messages/' + "1"])
                                    }
                                } else {
                                    this.ErrorMessages.push('Error while submitting data, please try again.')
                                    this.hasError = true
                                    this.focusableEleTop.nativeElement.focus()
                                }
                            })
                        // this.router.navigate(['enrollment/e-application/messages/5'])
                    }
                } else {
                    this.router.navigate(['/' + insCo + '/enrollment/e-application/messages/5'])
                    this.ErrorMessages.push('Error while submitting data, please try again.')
                    this.hasError = true
                    this.focusableEleTop.nativeElement.focus()
                }
            })
        }
    }
    rejectStep() {
        if (this.uniqueLink !== null && this.uniqueLink !== undefined) this.enrollmentViewModel.UNIQUELINK = this.uniqueLink
        this._enrollementGateway.setEnrollmentViewModel(this.enrollmentViewModel)
        const insCo = this._global.currentUser.insuranceCompanyShortName.toLowerCase()
        this.router.navigate(['/' + insCo + '/enrollment/e-application/confirmation/' + '2'])
    }
    onKeyDown(event) {
        const ENTER_KEY = 13
        if (event.keyCode === ENTER_KEY) {
            this.onSubmit()
        }
    }
}
